addEventListener("DOMContentLoaded", (event) => {
  const dropDownLists = document.querySelectorAll("li.header__linklist-item.has-dropdown");
  console.log(dropDownLists);
  dropDownLists.forEach((dropDownLi)=>{
    dropDownLi.addEventListener("mouseover",(ev)=>{
      const parentNodeEv = ev.target;
      const svgArrow = parentNodeEv.querySelector("svg");

      const parentSvg = svgArrow.parentNode;
      svgArrow.remove();
      
      console.log(parentSvg);

      const newSvg = document.createElement("svg");
      newSvg.innerHTML =
        `
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_16_119)">
            <path d="M2.04731 8.75L1.4375 8.20825L6.25 3.25L11.0625 8.20825L10.4527 8.75L6.25 4.42013L2.04731 8.75Z" fill="#F8F8F8"/>
            </g>
            <defs>
            <clipPath id="clip0_16_119">
            <rect width="11" height="11" fill="white" transform="matrix(-1 0 0 -1 11.75 11.5)"/>
            </clipPath>
            </defs>
          </svg>

        `
      
      parentSvg.insertBefore(newSvg, parentSvg.firstChild);
    })

    dropDownLi.addEventListener("mouseleave", (ev)=>{
      const parentNodeEv = ev.target;
      const svgArrow = parentNodeEv.querySelector("svg");

      const parentSvg = svgArrow.parentNode;
      svgArrow.remove();

      const newSvg = document.createElement("svg");
      newSvg.innerHTML =
        `
           <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.70269 2.75L10.3125 3.29175L5.5 8.25L0.6875 3.29175L1.29731 2.75L5.5 7.07987L9.70269 2.75Z" fill="#F8F8F8"/>
          </svg>

        `
      
      parentSvg.insertBefore(newSvg, parentSvg.firstChild);
      
    })
  })

})